<template>
  <div id="app" class="app">
    <transition :name="transitionName">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { loadGoogleCaptcha } from './regcpta'
export default {
  name: 'App',
  data() {
    return {
      transitionName: '',
      idx: '123'
    }
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.name !== 'home') {
        this.idx = from.name != this.idx ? to.name : from.name
        this.transitionName = from.name == this.idx ? 'slide-left' : 'slide-right'
      }
    }
  },
  mounted() {
    loadGoogleCaptcha()
  }
}
</script>

<style lang="less">
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

body {
  box-sizing: border-box;
  overflow-x: hidden;
}
.app {
  max-width: 650px;
  margin: 0 auto;
  height: 100%;
  box-sizing: border-box;
}
.mytit {
  padding: 10px;
  font-size: 24px;
  color: #159f42;
  background-color: rgba(21, 159, 66, 0.1);
}
.comtit {
  color: #159f42;
  font-weight: 600;
  font-size: 16px;
  margin: 15px 0 10px;
}
.comcont {
  font-size: 12px;
  color: #000;
  font-family: 'PingFang-SC-Medium';
  font-weight: 500;
  margin-bottom: 20px;
}
.dashed {
  margin: 20px 0;
  border-bottom: 1px dashed #159f42;
}
.com-tab-ttth {
  color: #159f42;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  margin: 20px 0;
}
.com-tab {
  .cenene {
    box-sizing: border-box;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    overflow: hidden;
    justify-content: center;
    .shihs {
      color: #141a22;
      font-weight: 700;
      background-color: #e5ebf5;
      flex: 1;
      padding: 10px 0;
      background-color: rgba(225, 235, 245, 0.5);
      font-size: 14px;
      text-align: center;
      &:nth-of-type(2) {
        border-left: 2px solid #fff;
        border-right: 2px solid #fff;
      }
    }
  }
  .com-tab-tit {
    display: flex;
    box-sizing: border-box;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    overflow: hidden;
    .topfour {
      flex: 1;
      padding: 5px;
      background-color: rgba(225, 235, 245, 0.5);
      color: #88a0c2;
      font-size: 14px;
      text-align: center;
      margin-left: 2px;
      position: relative;
      &.fos {
        font-size: 12px;
      }
      &:nth-of-type(1) {
        margin-left: 0;
      }
      &.active {
        color: #141a22;
        font-weight: 700;
        background-color: #e5ebf5;
      }
      &.active::before {
        content: '';
        position: absolute;
        width: 15px;
        height: 2px;
        background-color: #159f42;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
      }
    }
  }
  &-body {
    margin-top: 5px;
    margin-bottom: 20px;
    border: 1px solid #e5ebf5;
    border-radius: 0 0 5px 5px;
    font-size: 12px;
    &-txt {
      display: flex;
      .left {
        flex: 3;
        background-color: #fafbfd;
        color: #88a0c2;
        text-align: center;
        border-bottom: 1px solid #e5ebf5;
        border-right: 1px solid #e5ebf5;
        padding: 17px 0;
      }
      .right {
        flex: 5;
        text-align: center;
        color: #141a22;
        border-bottom: 1px solid #e5ebf5;
        padding: 17px 0;
        &.ddddd {
          flex: 1;
          padding: 8px !important;
          border-right: 1px solid #e5ebf5;
          &:nth-of-type(3n) {
            border-right: none;
          }
        }
      }
    }
    &:nth-last-of-type(1) {
      border-bottom: none;
    }
  }
}

.mint-indexlist-nav {
  position: fixed !important;
  padding: 5px 0;
  width: 20px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5) !important;
  border-radius: 8px;
  right: 10px !important;
  top: 80px !important;
  bottom: auto !important;
  color: #fff;
  border: none;
  display: block !important;
}
.mint-indexlist {
  &-content {
    margin-right: 0 !important;
    -webkit-overflow-scrolling: touch;
    // overflow-x: hidden;
    .mint-indexsection-index {
      background-color: #fff;
      font-size: 16px;
      padding: 0;
      color: #159f42;
      margin: 10px 0 15px;
    }
    ul {
      .mint-cell {
        min-height: 0;
        color: #159f42;
        .mint-cell-wrapper {
          padding: 0;
          font-size: 12px;
          margin: 5px 0;
        }
      }
    }
  }
}
.mint-indexlist-navitem {
  padding: 0 !important;
  margin-bottom: 3px;
}
.mint-popup-bottom {
  width: 100%;
}
.mint-msgbox {
  border-radius: 20px !important;
  .mint-msgbox-content {
    padding: 20px !important;
  }
  .mint-msgbox-message {
    color: #141a22 !important;
    font-size: 14px;
    text-align: left !important;
    line-height: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue